import React from 'react';
import { Box, Card, Grid, Icon, IconButton, styled, Tooltip } from '@mui/material';
import { Small } from '@components/Typography';
import { Typography } from 'antd';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
  cursor: 'pointer'
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '50px', color: '#0284c7' }
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '16px',
  fontWeight: '500',
  color: '#0284c7'
}));
const TextValue = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '20px',
  fontWeight: '500',
  color: '#0284c7'
}));

const StatCards = ({ deviceList, countDetail, status, setStatus }) => {
  const cardList = [
    {
      name: 'Tổng số thiết bị',
      total: countDetail?.total_devices,
      icon: 'access_time',
      status: 'all'
    },
    {
      name: 'Số lượng Online',
      total: countDetail?.total_online,
      icon: 'online_prediction',
      status: 'online'
    },
    {
      name: 'Số lượng Rớt mạng',
      total: countDetail?.total_offline,
      icon: 'portable_wifi_off',
      status: 'offline'
    }
  ];

  return (
    <Grid container spacing={3} sx={{ mb: '24px' }}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          <StyledCard elevation={4} onClick={() => setStatus(item?.status)}>
            <ContentBox>
              <Icon className="icon">{item.icon}</Icon>
              <Box ml="18px">
                <Heading sty>{item.name}</Heading>
                <TextValue>{item.total}</TextValue>
              </Box>
            </ContentBox>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatCards;
